import { Flex, Text } from '@raystack/apsara';
import clsx from 'clsx';

import styles from '@src/components/Custom/ModelCommonComponents/styles.module.css';
import { truncateText } from '@src/utils/commonUtils';

const CustomTooltipStackedGraph = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const content = payload[0] || {};
    const { payload: tooltipPayload = {} } = content;
    const { graphData, name } = tooltipPayload;
    return (
      <Flex
        className={clsx(styles.graphTooltipWrapper, styles.stackGraphTooltip)}
        direction='column'
        gap='medium'
        align='start'
      >
        <Text weight={500} size={2}>
          Data from {name.toLowerCase()} asset
        </Text>
        <Flex direction='column' align='start' gap='small'>
          {graphData.map((item, i) => (
            <Flex key={i} align='center' justify='between'>
              <div
                style={{
                  width: 7,
                  height: 7,
                  background: item.color,
                  borderRadius: 99999,
                  marginRight: 8
                }}
              />
              <Text
                className={clsx(styles.toolTipKey, styles.toolTipSecondaryText)}
                weight={400}
                size={2}
              >
                {truncateText(item.class, 18)}
              </Text>
              <Text
                weight={400}
                size={2}
                className={styles.toolTipSecondaryText}
              >
                {name === 'Reference' ? (
                  <>
                    : {item.refPercentage}% ({item.refArea}km<sup>2</sup>)
                  </>
                ) : (
                  <>
                    : {item.compPercentage}% ({item.compArea}km<sup>2</sup>)
                  </>
                )}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>
    );
  }
};

export default CustomTooltipStackedGraph;
